import { useRef, useState } from "react";
import Actionbar from "src/components/common/actionbar/Authactionbar";
import { Message } from "src/components/common/form/Message";
import { useMouseContent } from "src/utils/mouse/mouseContent";

import { useKSK2080_R01Store } from "./Store_KSK2080_R01";

import { AgGridReact } from "ag-grid-react";
import { Content_KSK2080_R01 } from "./Content_KSK2080_R01";
import { KSK2080_R01Dto } from "./Dto_KSK2080_R01";
import { Info_KSK2080_R01 } from "./Info_KSK2080_R01";
import { SearchSection_KSK2080_R01 } from "./SearchSection_KSK2080_R01";
import { Table_KSK2080_R01 } from "./Table_KSK2080_R01";

export const Container_KSK2080_R01 = () => {
	
	const { 
		KSK2080_R01Filter, setKSK2080_R01Filter,
		KSK2080_R01PastFilter, setKSK2080_R01PastFilter,
		allCount,
		initData,
	} = useKSK2080_R01Store();

	// leftWidth가 변경될 때 localStorage에 저장

	const RESIZER = {
		code: 'KSK2080_R01',
		type: 'width',
		storageKey: 'KSK2080_R01-split-width',
		min: 5,
		max: 80,
		default: 40
	} as const;
	const gridRef = useRef<AgGridReact<KSK2080_R01Dto>>(null);

	
	const containerRef = useRef<HTMLDivElement>(null);
	const infoRef = useRef<HTMLDivElement>(null);
	const isResizing = useRef(false);

	const { 
		splitValue,
		handleMouseDown,
		handleMouseUp
	} = useMouseContent({
		resizer: RESIZER,
		isResizing,
		containerRef,
		infoRef
	});

	const {
		handleExcelClick,
		defaultKSK2080_R01Row,
		fetchData,
		initContainerData,
		handleCreateClick,
		handleDeleteClick,
		handleSaveClick,
	} = Content_KSK2080_R01({
		gridRef,
		containerRef,
		
	});

	return (
	<div className="content-container">
		<Actionbar
			onFetchClick={fetchData}
			onCreateClick={handleCreateClick}
			onDeleteClick={handleDeleteClick}
			onSaveClick={handleSaveClick}
			onExcelClick={handleExcelClick}
			onInitClick={() => initData()}
			isDashboard={true}
		/>
		<SearchSection_KSK2080_R01 />
		<div className="flex flex-1 p-[12px] gap-[4px] min-h-0" ref={containerRef}>
			<div className="h-full" style={{ width: `${splitValue}%` }}>
				<Table_KSK2080_R01 gridRef={gridRef} />
			</div>
			<div
				className="w-[6px] bg-gray-100 cursor-col-resize hover:bg-gray-300"
				onMouseDown={(e: React.MouseEvent<HTMLDivElement>) => handleMouseDown('LR', e.nativeEvent)}
				data-comment="리사이저"
			/>
			<div className="h-full" style={{ width: `${100 - splitValue}%` }} ref={infoRef}>
				<Info_KSK2080_R01 />
			</div>
		</div>
	</div>
	)
}